import { useEffect, useState } from 'react';

export const useIsScrollTop = (): boolean => {
  const [isScrollTop, setIsScrollTop] = useState<boolean>(window.scrollY > 0 ? false : true);
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        setIsScrollTop(false);
      } else {
        setIsScrollTop(true);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [setIsScrollTop]);
  return isScrollTop;
};
